module.exports = __webpack_public_path__ + "static/media/company.ab8a0a16.svg";